import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { BarcodeResultDTO } from 'dm-src/dtos/barcode-result';

export const BARCODE_FACTORY_SERVICE_IMPL = new InjectionToken<IBarcodeFactoryService>(
    'barcodeFactoryServiceImpl'
);

export interface IBarcodeFactoryService {
    getBarcode(orderID: number): Observable<BarcodeResultDTO>;
}
